import { PagingPanel } from '@devexpress/dx-react-grid-material-ui'
import React from 'react'

const CustomContainer: React.FC<any> = (props) => {
  const { totalPages, ...restProps } = props

  return (
    <PagingPanel.Container
      {...restProps}
      totalPages={totalPages}
      onCurrentPageChange={(page) =>
        page !== Infinity ? restProps?.onCurrentPageChange?.(page) : undefined
      }
    />
  )
}

export const CustomPagingPanel: React.FC<any> = (props) => {
  return <PagingPanel {...props} containerComponent={CustomContainer} />
}
